import { WithClassname } from '../../../../types';
import { CheckboxOptionType, Flex, Form, Radio, Tag } from 'antd';
import React, { useMemo } from 'react';
import useOngoingOrder from '../../../../hooks/context/useOngoingOrder';
import { OrderPaymentType, OrderScheduleOption } from '../../../../types/constants';
import collect from 'collect.js';
import useStore from '../../../../hooks/context/useStore';
import { CreditCardOutlined, ShopOutlined } from '@ant-design/icons';

export default function PaymentMethodSelector({ className }: WithClassname) {
  const { storeData } = useStore();
  const { orderData, isExternalDelivery, updateOrderData } = useOngoingOrder();

  const hasCashPayments = storeData.payment_settings.has_cash_payments && !isExternalDelivery;

  const paymentTypeOptions = useMemo<CheckboxOptionType<OrderScheduleOption>[]>(
    () =>
      collect()
        .when(storeData.payment_settings.has_online_payments, (collection) =>
          collection.push({
            value: OrderPaymentType.Online,
            label: (
              <Flex gap="small">
                <CreditCardOutlined />
                <span>Pay online</span>
              </Flex>
            ),
          }),
        )
        .push({
          value: OrderPaymentType.InStore,
          disabled: !hasCashPayments,
          label: (
            <Flex gap="small">
              <ShopOutlined />
              <span>Pay in person (cash/card)</span>
              {hasCashPayments && (
                <Tag color="blue" className="h-fit my-auto">
                  Preferred
                </Tag>
              )}
            </Flex>
          ),
        })
        .toArray(),
    [storeData.payment_settings, hasCashPayments],
  );

  return (
    <div className={className}>
      <Form.Item
        layout="vertical"
        label={<h6 className="font-semibold">Payment type</h6>}
        className="mb-none"
      >
        <Radio.Group
          value={orderData.payment_type}
          onChange={(e) => updateOrderData('payment_type', e.target.value)}
          options={paymentTypeOptions}
          className="flex flex-col gap-sm"
        />
      </Form.Item>
    </div>
  );
}
